/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AgentHostPreview
 */
export interface AgentHostPreview {
  /**
   *
   * @type {string}
   * @memberof AgentHostPreview
   */
  convId: string;
  /**
   *
   * @type {string}
   * @memberof AgentHostPreview
   */
  branchRef: string;
  /**
   *
   * @type {string}
   * @memberof AgentHostPreview
   */
  sha: string;
  /**
   *
   * @type {number}
   * @memberof AgentHostPreview
   */
  backendPort: number;
  /**
   *
   * @type {number}
   * @memberof AgentHostPreview
   */
  backendPid?: number | null;
  /**
   *
   * @type {number}
   * @memberof AgentHostPreview
   */
  hubblePort?: number | null;
  /**
   *
   * @type {number}
   * @memberof AgentHostPreview
   */
  hubblePid?: number | null;
  /**
   *
   * @type {number}
   * @memberof AgentHostPreview
   */
  dashboardPort?: number | null;
  /**
   *
   * @type {number}
   * @memberof AgentHostPreview
   */
  dashboardPid?: number | null;
  /**
   *
   * @type {string}
   * @memberof AgentHostPreview
   */
  backendStatus: string;
  /**
   *
   * @type {string}
   * @memberof AgentHostPreview
   */
  hubbleStatus: string;
  /**
   *
   * @type {string}
   * @memberof AgentHostPreview
   */
  dashboardStatus: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof AgentHostPreview
   */
  startedAt: OffsetDateTime;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof AgentHostPreview
   */
  lastActiveAt: OffsetDateTime;
}

/**
 * Check if a given object implements the AgentHostPreview interface.
 */
export function instanceOfAgentHostPreview(
  value: object,
): value is AgentHostPreview {
  if (!("convId" in value) || value["convId"] === undefined) return false;
  if (!("branchRef" in value) || value["branchRef"] === undefined) return false;
  if (!("sha" in value) || value["sha"] === undefined) return false;
  if (!("backendPort" in value) || value["backendPort"] === undefined)
    return false;
  if (!("backendStatus" in value) || value["backendStatus"] === undefined)
    return false;
  if (!("hubbleStatus" in value) || value["hubbleStatus"] === undefined)
    return false;
  if (!("dashboardStatus" in value) || value["dashboardStatus"] === undefined)
    return false;
  if (!("startedAt" in value) || value["startedAt"] === undefined) return false;
  if (!("lastActiveAt" in value) || value["lastActiveAt"] === undefined)
    return false;
  return true;
}

export function AgentHostPreviewFromJSON(json: any): AgentHostPreview {
  return AgentHostPreviewFromJSONTyped(json, false);
}

export function AgentHostPreviewFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AgentHostPreview {
  if (json == null) {
    return json;
  }
  return {
    convId: json["convId"],
    branchRef: json["branchRef"],
    sha: json["sha"],
    backendPort: json["backendPort"],
    backendPid: json["backendPid"] == null ? undefined : json["backendPid"],
    hubblePort: json["hubblePort"] == null ? undefined : json["hubblePort"],
    hubblePid: json["hubblePid"] == null ? undefined : json["hubblePid"],
    dashboardPort:
      json["dashboardPort"] == null ? undefined : json["dashboardPort"],
    dashboardPid:
      json["dashboardPid"] == null ? undefined : json["dashboardPid"],
    backendStatus: json["backendStatus"],
    hubbleStatus: json["hubbleStatus"],
    dashboardStatus: json["dashboardStatus"],
    startedAt: json["startedAt"],
    lastActiveAt: json["lastActiveAt"],
  };
}

export function AgentHostPreviewToJSON(json: any): AgentHostPreview {
  return AgentHostPreviewToJSONTyped(json, false);
}

export function AgentHostPreviewToJSONTyped(
  value?: AgentHostPreview | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    convId: value["convId"],
    branchRef: value["branchRef"],
    sha: value["sha"],
    backendPort: value["backendPort"],
    backendPid: value["backendPid"],
    hubblePort: value["hubblePort"],
    hubblePid: value["hubblePid"],
    dashboardPort: value["dashboardPort"],
    dashboardPid: value["dashboardPid"],
    backendStatus: value["backendStatus"],
    hubbleStatus: value["hubbleStatus"],
    dashboardStatus: value["dashboardStatus"],
    startedAt: value["startedAt"],
    lastActiveAt: value["lastActiveAt"],
  };
}
